export default __webpack_public_path__ + "static/media/Y.efaa4ba3.svg";